import React from 'react';
import styled from 'styled-components';
import { Form } from 'react-bootstrap';

// --- Styled Components ---

export const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.25rem;

  .form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control,
  .form-select {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e0e0;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      border-color: #4b6cb7;
      box-shadow: 0 0 0 0.25rem rgba(75, 108, 183, 0.25);
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
`;

export const Feedback = ({ error }) => {
    if (!error) return null;
    return (
        <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
            <i className="bi bi-exclamation-circle me-2"></i>
            {error.message}
        </Form.Control.Feedback>
    );
};

// --- Constants ---

export const SCHOOL_FIXED_FEE = 1180;

export const SPECIALIZATIONS = [
    "Artificial Intelligence & Machine Learning",
    "Data Science",
    "Blockchain",
    "Cloud Computing",
    "Cybersecurity",
    "Internet of Things (IoT)",
    "Entrepreneurship and Innovation"
];

export const EXAM_FEES = {
    "UG 1": 1180, "UG 2": 1180, "UG 3": 1180, "UG 4": 1180,
    "PG 1": 1180, "PG 2": 1180,
};

export const UG_ELIGIBILITY = {
    1: ["UG 1"],
    2: ["UG 2", "UG 1"],
    3: ["UG 3", "UG 2", "UG 1"],
    4: ["UG 4", "UG 3", "UG 2", "UG 1"],
};

export const PG_ELIGIBILITY = {
    1: ["PG 1", "UG 1", "UG 2", "UG 3", "UG 4"],
    2: ["PG 2", "PG 1", "UG 1", "UG 2", "UG 3", "UG 4"],
};

export const ALL_EXAM_LEVELS = [
    "UG 1", "UG 2", "UG 3", "UG 4",
    "PG 1", "PG 2"
];

export const LEVELS = {
    SCHOOL: "school",
    UG: "ug",
    PG: "pg",
    INDIVIDUAL: "individual"
};

export const BOARD_OPTIONS = ["CBSE", "ISCE", "Stateboard", "IGCSE", "IB", "Others"];
export const COLLEGE_TYPES = ["Govt", "Aided", "Private", "Autonomous College", "Deemed-to-be University"];
export const MODES = ["Regular", "Distance"];

export const getDetailsPath = (level) => {
    switch (level) {
        case LEVELS.SCHOOL: return "schoolDetails";
        case LEVELS.UG: return "ugDetails";
        case LEVELS.PG: return "pgDetails";
        default: return "individualDetails";
    }
};
